import { Button, withStyles } from '@material-ui/core';

export default withStyles(() => ({
  root: {
    textTransform: 'none',
    lineHeight: 'inherit',
  },
}))(Button);
